<!-- partial:partials/_sidebar.html -->
<nav class="sidebar sidebar-offcanvas" id="sidebar">
    <ul class="nav">
        
        <!-- <li class="nav-item" *ngIf="isLogin()">
            <a class="nav-link" href="javascript:void(0)" routerLink="/event/multi-market" routerLinkActive="active"> 
                <i class="nav-icon fa-duotone fa-chart-tree-map"></i>
                Multi Market
            </a>
        </li> -->

        <li class="nav-item" *ngFor="let mn of menu;let i=index;trackBy:trackByIndex">
            
            <!-- casino -->
            <a class="nav-link" (click)="closeSidebar();" href="javascript:void(0)" *ngIf="events.casino.includes(mn?.id)" [routerLink]="['/casino', mn?.id]" routerLinkActive="active"> 
                <i class="nav-icon fa-duotone" [ngClass]="{
                    'fa-coin': mn.id==99999, 
                    'fa-slot-machine': mn.id==99995, 
                    'fa-coins': mn.id==99998
                }"></i>
                <span class="menu-title">{{mn?.name}}</span>
            </a>

            

            <!-- sports and races -->
            <a class="nav-link" data-bs-toggle="collapse" href="#ui-basic-{{i}}" aria-expanded="false"
                attr.aria-controls="ui-basic-{{i}}" *ngIf="!events.casino.includes(mn?.id)">
                <!-- election: nav-icon fa-duotone fa-vote-yea
                tennis: nav-icon fa-duotone fa-tennis-ball
                cricket: nav-icon fa-duotone fa-cricket-bat-ball
                horse: nav-icon fa-duotone fa-horse
                slot: nav-icon fa-duotone fa-slot-machine -->
                <i class="nav-icon fa-duotone " *ngIf="mn.id != 99994 && mn.id != 2378961" [ngClass]="{
                    'fa-football': mn.id==1, 
                    'fa-tennis-ball':mn.id==2,
                    'fa-cricket-bat-ball':mn.id==4, 
                    'fa-horse':mn.id==7,
                    'fa-dog':mn.id==4339
                }"></i>
                <img *ngIf="mn.id==99994 || mn.id==2378961" class="img-fluid" src="https://speedcdn.io/assets/parker-client/icons/{{mn.id}}.svg">
                <span class="menu-title">{{mn.name}}</span>
                <i class="menu-arrow"></i>
            </a>

            <!-- SPORTS LIST -->
            <div class="collapse" id="ui-basic-{{i}}" *ngIf="!events.casino.includes(mn?.id) && !events.races.includes(mn?.id)">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item" *ngFor="let smn of mn.child;let j=index;trackBy:trackByIndex"> 
                        <a class="nav-link" data-bs-toggle="collapse" href="#subLevelMenus{{i}}{{j}}" role="button" aria-expanded="false" aria-controls="subLevelMenus">
                            {{smn.name}}
                            <i class="menu-arrow"></i>
                        </a>
                        <div class="collapse" id="subLevelMenus{{i}}{{j}}">
                            <ul class="nav flex-column sub-menu-level">
                                <li class="nav-item" *ngFor="let item of smn.data;let k=index;trackBy:trackByIndex">
                                    <a class="nav-link" (click)="closeSidebar();" routerLinkActive="active" [routerLink]="['/event/detail', item?.event_id]">{{item.name}}</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
            
            <!-- RACE LIST -->
            <div class="collapse" id="ui-basic-{{i}}" *ngIf="events.races.includes(mn?.id)">
                <ul class="nav flex-column sub-menu">
                    <li class="nav-item" *ngFor="let item of mn.data;let j=index;trackBy:trackByIndex">
                        <a (click)="closeSidebar();" class="nav-link" routerLinkActive="active" href="javascript:void(0)"
                            [routerLink]="['/event/detail',item.event_id, item?.market_id]">
                            {{item.event_name}} ({{item.market_start_time_format | date: 'hh:mm a'}})
                        </a>
                    </li>
                </ul>
            </div>
        </li>
    </ul>
</nav>
<!-- partial -->